export default __webpack_public_path__ + "static/Logo-Dash-70b390d122f15a39c0a8b8f65e313fae.png";